/**
 * API Limits Configuration
 * Defines rate limits and usage limits for various APIs
 */

export const API_LIMITS = {
  // Google Maps API limits
  GOOGLE_DAILY_LIMIT: 1000,
  GOOGLE_MONTHLY_BUDGET: 200, // $200 per month
  GOOGLE_COST_PER_REQUEST: 0.00283, // $2.83 per 1000 requests
  
  // OpenCage API limits
  OPENCAGE_DAILY_LIMIT: 2500,
  OPENCAGE_MONTHLY_LIMIT: 75000,
  
  // OpenStreetMap API limits
  OSM_HOURLY_LIMIT: 1000,
  OSM_DAILY_LIMIT: 10000,
  
  // General rate limits
  MAX_REQUESTS_PER_MINUTE: 60,
  MAX_REQUESTS_PER_HOUR: 1000,
  MAX_REQUESTS_PER_DAY: 10000,
  
  // Cache limits
  MAX_CACHE_SIZE: 1000,
  CACHE_TTL: 300000, // 5 minutes
  MAX_LEARNED_LOCATIONS: 1000,
  
  // Performance limits
  MAX_QUERY_LENGTH: 100,
  MIN_QUERY_LENGTH: 2,
  MAX_SUGGESTIONS: 10,
  MAX_RESULTS_PER_API: 5,
  
  // Timeout limits
  API_TIMEOUT: 5000, // 5 seconds
  CACHE_TIMEOUT: 1000, // 1 second
  DATABASE_TIMEOUT: 3000, // 3 seconds
};

export default API_LIMITS;